import React, { Component } from 'react';
import QrReader from 'react-qr-reader';
import { MainContainer, Paragraph, Button } from './StyledComponents';

export default class QRScanningForPrinter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: null,
      facingMode: 'environment',
      legacyMode: false,
    };
    this.handleError = this.handleError.bind(this);
    this.handleScan = this.handleScan.bind(this);
    this.handleImgSubmit = this.handleImgSubmit.bind(this);
  }

  async handleScan(data) {
    if (data && typeof data !== 'object') {
      const result = data;
      this.setState({ result });
    } else {
      this.setState({ result: 'Incomplete Information. Please scan again' });
    }
  }

  handleError() {
    this.setState({ result: 'Please Try Again!', legacyMode: true });
  }

  handleImgSubmit() {
    // eslint-disable-next-line react/no-string-refs
    this.refs.reader.openImageDialog();
  }

  render() {
    const { result, facingMode, legacyMode } = this.state;
    return (
      <div>
        {!legacyMode ? (
          <div style={{ height: '100vh', width: '100vw' }}>
            <QrReader
              delay={300}
              onError={this.handleError}
              onScan={this.handleScan}
              style={{ height: '100vh', width: '100vw' }}
              facingMode={facingMode}
              legacyMode={legacyMode}
              className="qr-scanner"
            />
          </div>
        ) : (
          <MainContainer>
            <Paragraph>
              Unfortunately we do not support QR Code Scanning, but please
              upload a photo
            </Paragraph>
            <Button onClick={this.handleImgSubmit}>QR Code Image</Button>
            <QrReader
              onScan={this.handleScan}
              onError={this.handleError}
              onLoad={this.handleLoad}
              facingMode={facingMode}
              delay={false}
              onImageLoad={this.handleImageLoad}
              legacyMode={legacyMode}
              // eslint-disable-next-line react/no-string-refs
              ref="reader"
            />
          </MainContainer>
        )}
        <Paragraph className="qr-status">{result}</Paragraph>
      </div>
    );
  }
}
